<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable vue/valid-v-slot -->
<template>
  <v-container fluid>
    <v-row align="center" justify="space-between" class="m-4 mx-1 mt-4">
      <h2 class="font-weight-bold">{{ $t("all_users") }}</h2>
      <v-btn color="warning" dark :to="'/dashboard/users/add'">
        {{ $t("add_user") }}
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          :label="$t('filter_by_name')"
          outlined
          dense
          v-model="filter"
          @input="fetchUsers"
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="translatedHeaders"
      :items="users"
      :server-items-length="totalItems"
      :loading="loading"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      :footer-props="{
        'items-per-page-options': [10, 20, 50],
        'items-per-page-text': $t('rows_per_page'),
      }"
      class="elevation-1"
      @update:page="fetchUsers"
      @update:items-per-page="fetchUsers"
    >
      <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
        {{
          $t("pagination", {
            start: pageStart,
            end: pageStop,
            total: itemsLength,
          })
        }}
      </template>
      <template v-slot:item.id="{ item }">
        <a class="blue--text text--darken-2" @click.prevent="viewUser(item)">
          {{ item.id }}
        </a>
      </template>

      <template v-slot:item.contact="{ item }">
        <div>
          {{ $t("phone") }}: {{ item.phone }}<br />
          {{ $t("email") }}: {{ item.email }}
        </div>
      </template>

      <template v-slot:item.role="{ item }">
        {{ item.role.name }}
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip color="green" dark small v-if="item.status">
          {{ $t("active") }}
        </v-chip>
        <v-chip color="red" dark small v-else>
          {{ $t("inactive") }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="viewUser(item)">
              <v-list-item-title>{{ $t("view_user") }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="viewUser(item)">
              <v-list-item-title>{{ $t("update_user") }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="getPermission(item)" v-if="$store.state.user.role_id === 1">
              <v-list-item-title>{{
                $t("update_permission")
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <v-dialog v-model="permissionDialog" max-width="600px">
      <v-card>
        <v-card-title class="headline mb-5">{{
          $t("update_permission")
        }}</v-card-title>
        <v-card-text>
          <v-checkbox
            v-for="(item) in userPermissions"
            :key="item.id"
            :label="item.name"
            v-model="item.permission"
            :value="1"
            :false-value="0"
            :true-value="1"
            style="margin: 0"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="permissionDialog = false">{{
            $t("cancel")
          }}</v-btn>
          <v-btn color="warning" dark @click="updatePermissions">{{
            $t("update")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import api from "../services/axios";

export default {
  data() {
    return {
      permissionDialog: false,
      userPermissions: [],
      selectedUserId: null,

      loading: false,
      users: [],
      filter: "",
      totalItems: 0,
      pagination: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        { text: "id", value: "id" },
        { text: "first_name", value: "first_name" },
        { text: "last_name", value: "last_name" },
        { text: "contact_information", value: "contact", sortable: false },
        { text: "role", value: "role" },
        { text: "status", value: "status" },
        { text: "action", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    translatedHeaders() {
      return this.headers.map((header) => ({
        ...header,
        text: this.$t(header.text),
      }));
    },
  },
  methods: {
    async fetchUsers() {
      this.loading = true;
      try {
        const res = await api.get("/employee", {
          params: {
            perPage: this.pagination.itemsPerPage,
            page: this.pagination.page,
            filter: this.filter,
          },
        });
        this.users = res.data.data.data || [];
        this.totalItems = res.data.data.total_records || 0; // adapt if total comes from res.data.meta.total
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    viewUser(user) {
      console.log("View", user);
      this.$router.push("users/update/" + user.id);
    },
    editUser(user) {
      console.log("Edit", user);
      this.$router.push("users/update/" + user.id);
    },
    deleteUser(user) {
      console.log("Delete", user);
    },
    async updatePermissions() {
      try {
        const selectedPermissions = this.userPermissions
          .filter((p) => p.permission === 1)
          .map((p) => p.id);

        const formData = new FormData();
        selectedPermissions.forEach((id, index) => {
          formData.append(`permission[${index}]`, id);
        });

        const res = await api.post(
          `/employee/permission/add/${this.selectedUserId}`,
          formData
        );
        if (!res.data.status) {
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "error",
          });
        } else {
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "success",
          });
          this.permissionDialog = false;
        }
      } catch (err) {
        console.error("Failed to update permissions", err);
      }
    },

    async getPermission(item) {
      try {
        const res = await api.get(`/employee/permission/${item?.id}`);
        this.userPermissions = res.data.data.map((p) => ({
          ...p,
          permission: p.permission ? 1 : 0,
        }));
        this.selectedUserId = item.id;
        this.permissionDialog = true;
      } catch (err) {
        console.error(err);
      }
    },
  },
  async mounted() {
    this.fetchUsers();
  },
};
</script>
